import {withStyles} from "@mui/styles";
import {TextField} from "@mui/material";

const NautilusText = withStyles({
    root: {
        backgroundColor:'white',
        '& label.Mui-focused': {
            color: '#1ebce7',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#1ebce7',
        },
        '& .MuiOutlinedInput-root': {
            borderRadius: 2,
            fontSize:18,
            fontWeight:600,
            color:'#1ebce7',
            '& .MuiNativeSelect-outlined': {
                paddingTop: 10,
                paddingBottom: 10,
            },
            '& fieldset': {
                borderColor: '#1ebce7',
            },
            '&:hover fieldset': {
                borderColor: '#1ebce7',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#1ebce7',
            },
        },
    },
})(TextField);

export default NautilusText;